import {CustomNodeModel} from '@/components/Canvas/customNodes/CustomNodeModel'
import {SendEmailNodeModel} from '@/components/Canvas/customNodes/SendEmail/SendEmailNodeModel'
import {SendEmailNodeWidget} from '@/components/Canvas/customNodes/SendEmail/SendEmailNodeWidget'
import {NodeTypeEnum} from '@/types/NodeTypeEnum'
import {GenerateWidgetEvent} from '@projectstorm/react-canvas-core'
import {CustomNodeFactory} from '../CustomNodeFactory'

export class SendEmailNodeFactory extends CustomNodeFactory {
  constructor() {
    super(NodeTypeEnum.sendEmail)
  }

  generateReactWidget(event: GenerateWidgetEvent<CustomNodeModel>): React.JSX.Element {
    return <SendEmailNodeWidget engine={this.engine} node={event.model} />
  }

  generateModel() {
    return new SendEmailNodeModel()
  }
}
